import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostAgentMonthCommissionExtraList } from '@/services/wms/commission';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        agentId: this.$route.query.agentId,
        month: this.$route.query.month,
        year: this.$route.query.year
      },
      btnLoading: false,
      listRequest: rqtPostAgentMonthCommissionExtraList,
      codeResItems: [{
        title: '加扣款类型',
        dataIndex: 'plusType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'plusType'
      }]
    };
  },
  computed: {},
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {}
};